import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import { Card, CardHeader, CardBody, CardFooter, Collapse, Tooltip } from 'reactstrap';
import { Checkbox, Radio, Switch } from 'pretty-checkbox-react';

class Scoresheet extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			scheduledMatch: {},
			scoresheetStatus: "",
			scoresheet: {},
			scoresheetFormat: {},
			currentRound: 1,
			loading: true,

			dummyScores: {
				sc1: 10,
				sc2: 5,
				ero: true,
				tv: true
			}
		};

		this.handleChangeScore1 = this.handleChangeScore1.bind(this);
		this.handleClickScore1 = this.handleClickScore1.bind(this);
		this.handleChangeScore2 = this.handleChangeScore2.bind(this);
		this.handleClickScore2 = this.handleClickScore2.bind(this);

		this.handleClickEro = this.handleClickEro.bind(this);
		this.handleClickTv = this.handleClickTv.bind(this);
	}

	componentDidMount() {
		//console.log('Scoresheet: componentDidMount')
		document.body.classList.toggle('sidebar-hidden');
		this.getScheduledMatchInfo(this.props.match.params.scheduledMatchId)
	}

	getScheduledMatchInfo(scheduledMatchId) {
		var _this = this;
		Axios.get('/api/scheduledMatchs/initScoresheet2/' + scheduledMatchId)
			.then(function(responseScheduledMatch) {
				_this.setState({
					scheduledMatch: responseScheduledMatch.data.scheduledMatch,
					scoresheetStatus: responseScheduledMatch.data.scoresheetStatus,
					scoresheet: responseScheduledMatch.data.scoresheet,
					scoresheetFormat: responseScheduledMatch.data.scoresheetFormat,
				});
		});
	}

 	render() {
		console.log('Scoresheet: render');
		console.log(this.state);

		return (
			<div className="animated fadeIn row-margin-bottom-100">
				{this.showHeader()}
				{this.showRounds()}
				<hr className="hr-nomargin double"/>

				{this.showMatchSummary()}
				<hr className="hr-nomargin"/>

			</div>
		);
	}

	showHeader() {
		return (
			<div>
			<div className="row ss2-title">
			<div className="col-lg-12">
				<h4>Feuille de Pointage</h4>
			</div>
			</div>
			<hr className="hr-nomargin double"/>

			<div className="row ss2-header-row">
			<div className="col-12 col-lg-6">
				<p className="small-margin">
					<strong>Ligue: </strong>{this.state.scheduledMatch.seasonName} <br/>
					<strong>Sous-saison: </strong>{this.state.scheduledMatch.subSeasonName} <br/>
					<strong>Programme: </strong>{this.state.scheduledMatch.week}
				</p>
			</div>

			<div className="col-12 col-lg-6">
				<p className="small-margin">
					<strong>Date: </strong>{moment(this.state.scheduledMatch.date).utc().format("YYYY-MM-DD")} <br/>
					<strong>Lieu: </strong>{this.state.scheduledMatch.locationName} <br/>
					<strong>Local: </strong>{this.state.scheduledMatch.team1Name} <br/>
					<strong>Visiteur: </strong>{this.state.scheduledMatch.team2Name}
				</p>
			</div>
			</div>
			<hr className="hr-nomargin double"/>
			</div>
		);

	}

	showRounds() {
		var currentRound = this.state.currentRound;
		return (
			<div className="row ss2-rounds-container">
				{/* Show one / multiple rounds */}
				{this.showRound(currentRound)}
				{this.showRound(currentRound + 1)}
				{this.showRound(currentRound + 2)}

			</div>
		);
	}

	showRound(round) {
		var nbRounds = this.state.scoresheetFormat.nbRounds;
		
		var showLeftArrow = (round === this.state.currentRound);
		var showRightArrowSmallScreen = (round === this.state.currentRound);
		var showRightArrowLargeScreen = (round === this.state.currentRound + 2);

		var nbRounds = this.state.scoresheetFormat.nbRounds;
		var viewportExclusionRounds = "";
		if (round !== this.state.currentRound) {
			viewportExclusionRounds = "not-on-smallscreen";
		}


		return (
			<div className={"col-lg-4 col-12 ss2-round-box " + viewportExclusionRounds}>

				{showLeftArrow ? 
					<span className="ss2-roundscroll-btn ss2-roundscroll-btn-left" onClick={this.handleRoundScroll.bind(this, -1)} > &lt; </span>
					: null}

				<h4 className="ss2-round-title">Ronde {round} {/*{nbRounds}*/}</h4>
				<hr className="ss2-hr-match"/>

				{this.showMatch(1)}
				{this.showMatch(2)}
				{this.showMatch(3)}
				{this.showMatch(4)}

				{/* display right scroll button here */}
				{showRightArrowSmallScreen ? 
				<span className="ss2-roundscroll-btn ss2-roundscroll-btn-right only-on-smallscreen" 
					onClick={this.handleRoundScroll.bind(this, 1)}> &gt; </span>
					: null}

				{showRightArrowLargeScreen ? 
				<span className="ss2-roundscroll-btn ss2-roundscroll-btn-right not-on-smallscreen" 
					onClick={this.handleRoundScroll.bind(this, 1)}> &gt; </span>
					: null}

				{this.showRoundSummary()}

			</div>
		)
	}

	showMatch(match) {
		return (
			<div>
			<div className="ss2-rnd-player-box">
				<div className="ss2-rnd-box1">
					{match}
				</div>
				<div className="ss2-rnd-box2">
					<span> Pat Poulin </span> <br/>
					<span className="ss2-rnd-text-pstats"> 3-1 </span>
				</div>
				<div className="ss2-rnd-box3">
					{/*<div className="ss2-rnd-scorebox-box"></div>*/}
        	<input className="ss2-rnd-scorebox-score no-spinners" type="number" id="sc1" 
        		value={this.state.dummyScores.sc1} 
        		onClick={this.handleClickScore1}
        		onChange={this.handleChangeScore1}>
        	</input>

        	{/* EXAMPLE of using a circle to mark an Ero against - to fine tune*/}
        	{/*<span className="ss2-ero-circled" onClick={this.handleClickScore1}> </span>*/}

				</div>

					<div className="ss2-rnd-erobox-container">
		    	<input className="ss2-rnd-erobox-box ss2-rnd-erobox-box1" type="text" id="ebox" 
		    		value={(this.state.dummyScores.ero ? "x" : '')} 
		    		onClick={this.handleClickEro} readOnly>
		    	</input>
					<div className="ss2-rnd-erobox-title ss2-rnd-erobox-title1"> ERO </div>

		    	<input className="ss2-rnd-erobox-box ss2-rnd-erobox-box2" type="text" id="tvbox" 
		    		value={(this.state.dummyScores.tv ? "x" : '')} 
		    		onClick={this.handleClickTv} readOnly>
		    	</input>
					<div className="ss2-rnd-erobox-title ss2-rnd-erobox-title2"> TV </div>
					</div>

				</div>

			<div className="ss2-rnd-player-box">
			<div className="ss2-rnd-box1">
				{match + 4}
			</div>
			<div className="ss2-rnd-box2">
				<span className="span-limite"> Zachary-Étienne Sanschagrin-Poitras </span> <br/>
				<span className="ss2-rnd-text-pstats"> 1-3 </span>
			</div>
			<div className="ss2-rnd-box3">
				{/*<div className="ss2-rnd-scorebox-box"></div>*/}

      	<input className="ss2-rnd-scorebox-score no-spinners" type="number" id="sc2" 
      		value={this.state.dummyScores.sc2} 
      		onClick={this.handleClickScore2}
      		onChange={this.handleChangeScore2}>
      	</input>

			</div>
			</div>

			<hr className="ss2-hr-match"/>
			</div>			
		)
	}

	showRoundSummary() {

		return (
			<div className="ss2-rnd-summary-box">
				<div className="ss2-rnd-summary-box2">
				<div className="ss2-rnd-summary-title">
					RONDE
				</div>
				<div className="ss2-rnd-summary-headers">
					<div className="ss2-rnd-summary-hdrcol ss2-rnd-summary-hdr1">
						STOT
					</div>
					<div className="ss2-rnd-summary-hdrcol">
						HCP
					</div>
					<div className="ss2-rnd-summary-hdrcol">
						TOT
					</div>
				</div>

				<div className="ss2-rnd-summary-team">
					<div className="ss2-rnd-summary-team-title">
						LOC
					</div>
					<div className="ss2-rnd-summary-team-col ss2-rnd-summary-team-col1">
						34
					</div>
					<div className="ss2-rnd-summary-team-col">
						2
					</div>
					<div className="ss2-rnd-summary-team-col">
						36
					</div>
					<div className="ss2-rnd-summary-team-col ss2-rnd-summary-team-colpt">
						X
					</div>
				</div>
				<div className="ss2-rnd-summary-team">
					<div className="ss2-rnd-summary-team-title">
						VIS
					</div>
					<div className="ss2-rnd-summary-team-col ss2-rnd-summary-team-col1">
						26
					</div>
					<div className="ss2-rnd-summary-team-col">
						-
					</div>
					<div className="ss2-rnd-summary-team-col">
						26
					</div>
					<div className="ss2-rnd-summary-team-col ss2-rnd-summary-team-colpt">
						
					</div>
				</div>
				</div>
			</div>
		)
	}

	showMatchSummary() {
		return (
			<div className="row">
			<div className="col-lg-4 col-12 ss2-match-summary-box1">
				<div className="ss2-match-summary-box2">

				<div className="ss2-match-summary-title">
					MATCH
				</div>

				<div className="ss2-match-summary-headers">
					<div className="ss2-match-summary-hdrcol ss2-match-summary-hdr1"> 1 </div>
					<div className="ss2-match-summary-hdrcol"> 2 </div>
					<div className="ss2-match-summary-hdrcol"> 3 </div>
					<div className="ss2-match-summary-hdrcol"> 4 </div>
					<div className="ss2-match-summary-hdrcol"> 5 </div>
					<div className="ss2-match-summary-hdrcol"> 6 </div>
					<div className="ss2-match-summary-hdrcol"> 7 </div>
					<div className="ss2-match-summary-hdrcol"> 8 </div>
					<div className="ss2-match-summary-hdrcol ss2-match-summary-tot1"> M </div>
					<div className="ss2-match-summary-hdrcol ss2-match-summary-tot2"> TOT </div>
					<div className="ss2-match-summary-hdrcol ss2-match-summary-tot3"> PR </div>
				</div>

				<div className="ss2-match-summary-team">
					<div className="ss2-match-summary-team-title"> LOC </div>
					<div className="ss2-match-summary-team-col ss2-match-summary-team-col1"> X </div>
					<div className="ss2-match-summary-team-col"> X </div>
					<div className="ss2-match-summary-team-col"> - </div>
					<div className="ss2-match-summary-team-col"> - </div>
					<div className="ss2-match-summary-team-col"> X </div>
					<div className="ss2-match-summary-team-col"> - </div>
					<div className="ss2-match-summary-team-col">  </div>
					<div className="ss2-match-summary-team-col">  </div>

					<div className="ss2-match-summary-team-col ss2-match-summary-team-colpts1"> X </div>
					<div className="ss2-match-summary-team-col ss2-match-summary-team-colpts2"> 283 </div>
					<div className="ss2-match-summary-team-col ss2-match-summary-team-colpts3"> 5.5 </div>
				</div>

				<div className="ss2-match-summary-team">
					<div className="ss2-match-summary-team-title"> VIS </div>
					<div className="ss2-match-summary-team-col ss2-match-summary-team-col1"> - </div>
					<div className="ss2-match-summary-team-col"> - </div>
					<div className="ss2-match-summary-team-col"> X </div>
					<div className="ss2-match-summary-team-col"> X </div>
					<div className="ss2-match-summary-team-col"> - </div>
					<div className="ss2-match-summary-team-col"> X </div>
					<div className="ss2-match-summary-team-col">  </div>
					<div className="ss2-match-summary-team-col">  </div>

					<div className="ss2-match-summary-team-col ss2-match-summary-team-colpts1">  </div>
					<div className="ss2-match-summary-team-col ss2-match-summary-team-colpts2"> 185 </div>
					<div className="ss2-match-summary-team-col ss2-match-summary-team-colpts3"> 3.5 </div>
				</div>

				</div>
			</div>
			</div>
		)
	}

	handleRoundScroll(opt) {
		var currentRound = this.state.currentRound;
		currentRound += opt;
		this.setState({	currentRound: currentRound });
	}

	handleClickScore1(e) {
		var dummyScores = this.state.dummyScores;
		dummyScores.sc1 = "";
		this.setState({
			dummyScores: dummyScores
		});		
	}
	handleClickScore2(e) {
		var dummyScores = this.state.dummyScores;
		dummyScores.sc2 = "";
		this.setState({
			dummyScores: dummyScores
		});		
	}
	handleClickEro(e) {
		var dummyScores = this.state.dummyScores;
		dummyScores.ero = !e.target.value;
		this.setState({
			dummyScores: dummyScores
		});		
	}
	handleClickTv(e) {
		var dummyScores = this.state.dummyScores;
		dummyScores.tv = !e.target.value;
		this.setState({
			dummyScores: dummyScores
		});		
	}

	handleChangeScore1(e) {
		var dummyScores = this.state.dummyScores;
		dummyScores.sc1 = e.target.value;
		this.setState({
			dummyScores: dummyScores
		});
	}
	handleChangeScore2(e) {
		var dummyScores = this.state.dummyScores;
		dummyScores.sc2 = e.target.value;
		this.setState({
			dummyScores: dummyScores
		});
	}

}

export default Scoresheet;


